import React, { Component } from 'react';
import './Title.css';

class Title extends Component {
  render() {
    return (
      <div className = "Title">
        <span>{this.props.label}</span>
        <i className = "fa fa-times" onClick = {this.props.onClose}></i>
      </div>
    );
  }
}

export default Title;



// WEBPACK FOOTER //
// ./src/ui/Title.js